import React from 'react';
import { FaWeight, FaCamera, FaClipboardCheck, FaCalendarWeek } from 'react-icons/fa';

const DashboardStats = ({ data }) => {
  const stats = [
    {
      icon: FaCalendarWeek,
      label: 'Current Week',
      value: data?.currentWeek || 1,
      suffix: '',
      color: 'primary',
    },
    {
      icon: FaClipboardCheck,
      label: 'Check-ins',
      value: data?.totalCheckIns || 0,
      suffix: '',
      color: 'success',
    },
    {
      icon: FaCamera,
      label: 'Photos',
      value: data?.totalPhotos || 0,
      suffix: '',
      color: 'purple',
    },
    {
      icon: FaWeight,
      label: 'Latest Weight',
      value: data?.latestCheckIn?.weight || '-',
      suffix: data?.latestCheckIn?.weight ? ' kg' : '',
      color: 'accent',
    },
  ];

  const colorClasses = {
    primary: {
      bg: 'bg-primary-100',
      icon: 'text-primary-600',
      text: 'text-primary-700',
    },
    success: {
      bg: 'bg-success-100',
      icon: 'text-success-600',
      text: 'text-success-700',
    },
    purple: {
      bg: 'bg-purple-100',
      icon: 'text-purple-600',
      text: 'text-purple-700',
    },
    accent: {
      bg: 'bg-accent-100',
      icon: 'text-accent-600',
      text: 'text-accent-700',
    },
  };

  return (
    <>
      {stats.map((stat, index) => {
        const colors = colorClasses[stat.color];
        return (
          <div
            key={index}
            className="bg-white rounded-xl shadow-lg p-6 flex items-center gap-4"
          >
            <div className={`w-12 h-12 ${colors.bg} rounded-xl flex items-center justify-center`}>
              <stat.icon className={`text-xl ${colors.icon}`} />
            </div>
            <div>
              <p className="text-sm text-gray-500">{stat.label}</p>
              <p className={`text-2xl font-bold ${colors.text}`}>
                {stat.value}{stat.suffix}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default DashboardStats;
